import React from "react";
import "./SoftwareSkill.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import pogo from "../../assests/images/srm.png"

function switching(logo){
  switch (logo.skillName){
    case 'ROS':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
    case 'Matlab':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
    case 'Raspberry Pi':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
    case 'Fusion 360':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
    case 'Tensorflow':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
    case 'TinyML':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
    case 'Adobe Illustrator':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="60px" height="60px"></img></div>;
    case 'Arduino':
      return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
      case 'Espressif':
        return <div className="in" name={logo.skillName}><img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="48px" height="48px"></img></div>;
    default: return (
    <div className="software-skill-inline" name={logo.skillName}>
      <span
        className="iconify"
        data-icon={logo.fontAwesomeClassname}
        style={logo.style}
        data-inline="false"
  ></span></div>
    );
  }
}
function SoftwareSkill(props) {
  const logo = props.softwareSkills;
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {props.logos.map((logo) => {
            return(
              <OverlayTrigger
                key={logo.skillName}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    <strong>{logo.skillName}</strong>
                  </Tooltip>
                }
              >
            <div className="software-skill-in" name={logo.skillName}>
              {switching(logo)}
            </div>
              </OverlayTrigger>
            );
            // return (
            //   <>
            //   <OverlayTrigger
            //     key={logo.skillName}
            //     placement={"top"}
            //     overlay={
            //       <Tooltip id={`tooltip-top`}>
            //         <strong>{logo.skillName}</strong>
            //       </Tooltip>
            //     }
            //   >
               
            //   <div className="software-skill-in" name={logo.skillName}>
            //     <li className="software-skill-in">
            //       {(logo.skillName=="ROS")?<img  src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="10%" height="15%"></img>: null }
            //       {logo.skillName=="Matlab"?<img src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="10%" height="15%"></img>: null }
            //       {logo.skillName=="Fusion 360"?<img src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="10%" height="15%"></img>: null }
            //       {logo.skillName=="Raspberry Pi"?<img src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="10%" height="15%"></img>: null }
            //       {logo.skillName=="Tensorflow"?<img src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="10%" height="15%"></img>: null }
            //       {logo.skillName=="TinyML"?<img src={require(`../../assests/images/${logo.logo_path}`)} alt="Eric" width="10%" height="15%"></img>: null }
            //       {logo.skillName=="Git"?<span
            //         className="iconify"
            //         data-icon={logo.fontAwesomeClassname}
            //         style={logo.style}
            //         data-inline="false"
            //       ></span>: null }
            //     </li>
            //     {/* <li className="software-skill-inline" name={logo.skillName}>
            //       <span
            //         className="iconify"
            //         data-icon={logo.fontAwesomeClassname}
            //         style={logo.style}
            //         data-inline="false"
            //       ></span>
            //     </li> */}
            //     </div>
            //   </OverlayTrigger>
            //   </>
            
            // );
          })}
          
        </ul>
      </div>
    </div>
  );
}


export default SoftwareSkill;
